var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.8958V1.6144C0 0.72273 0.72273 0 1.6144 0H26.8958C27.7875 0 28.5102 0.72273 28.5102 1.6144C28.5102 2.50607 27.7875 3.2288 26.8958 3.2288H3.2288V26.8958C3.2288 27.7875 2.50607 28.5102 1.6144 28.5102C0.72273 28.5102 0 27.7873 0 26.8958ZM26.896 96.771H3.2288V73.1038C3.2288 72.2121 2.50607 71.4894 1.6144 71.4894C0.72273 71.4894 0 72.2121 0 73.1038V98.3854C0 99.2771 0.72273 99.9998 1.6144 99.9998H26.8958C27.7875 99.9998 28.5102 99.2771 28.5102 98.3854C28.5102 97.4937 27.7875 96.771 26.896 96.771ZM98.3856 0H73.104C72.2123 0 71.4896 0.72273 71.4896 1.6144C71.4896 2.50607 72.2123 3.2288 73.104 3.2288H96.771V26.8958C96.771 27.7875 97.4937 28.5102 98.3854 28.5102C99.2771 28.5102 99.9998 27.7875 99.9998 26.8958V1.6144C100 0.72273 99.2773 0 98.3856 0ZM98.3856 71.4896C97.4939 71.4896 96.7712 72.2123 96.7712 73.104V96.771H73.104C72.2123 96.771 71.4896 97.4937 71.4896 98.3854C71.4896 99.2771 72.2123 99.9998 73.104 99.9998H98.3856C99.2773 99.9998 100 99.2771 100 98.3854V73.1038C100 72.2123 99.2773 71.4896 98.3856 71.4896ZM78.0318 67.1131L50.8074 82.8337C50.5576 82.978 50.2788 83.05 50 83.05C49.7212 83.05 49.4424 82.978 49.1926 82.8337L21.9682 67.1131C21.4688 66.8246 21.1612 66.2918 21.1612 65.715V34.2846C21.1612 33.7078 21.4688 33.175 21.9682 32.8865L49.1926 17.1657C49.6924 16.877 50.3076 16.877 50.8074 17.1657L78.0318 32.8865C78.5312 33.175 78.8388 33.7078 78.8388 34.2846V65.715C78.8388 66.2916 78.531 66.8246 78.0318 67.1131ZM26.0044 34.2844L50 48.1358L73.9956 34.2844L50 20.428L26.0044 34.2844ZM24.39 64.783L48.3856 78.6392V50.932L24.39 37.0806V64.783ZM75.61 64.783V37.0806L51.6144 50.932V78.6394L75.61 64.783Z",
    fill: "url(#paint0_linear_653_3787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_653_3787",
    x1: 0.472949,
    y1: 99.5268,
    x2: 99.5271,
    y2: 0.472743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99CFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00608A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem);
export default __webpack_public_path__ + "static/media/item.ea23ad17c22d435a6f92a3e873efac85.svg";
export { ForwardRef as ReactComponent };